import styled from "styled-components";
import { vars } from "@pancakeswap/ui/css/vars.css";
import { Box, Flex } from "../Box";
import SocialLinks from "./Components/SocialLinks";

export const StyledFooter = styled(Flex)`
  background: ${({ theme }) => theme.colors.backgroundAlt};
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  color: ${({ theme }) => theme.colors.text};
`;

export const StyledList = styled.ul`
  list-style: none;
  margin-bottom: 40px;

  ${({ theme }) => theme.mediaQueries.md} {
    margin-bottom: 0px;
  }
`;

/* site review 59 #8 (2026-10-08): a footer link is 24 px of text with a 44 px hit area (padding pulled back by margins); the items sit
   20 px apart so neighbouring hit areas do not overlap */
export const StyledListItem = styled.li`
  font-size: 16px;
  margin-bottom: 20px;

  & > a {
    padding: 10px 0;
    margin: -10px 0;
  }

  &:first-child {
    color: ${({ theme }) => theme.colors.text};
    font-weight: 700;
    margin-bottom: 1.5rem;
    font-size: 18px;
    font-family: ${vars.fonts.display};
  }
`;

export const StyledIconMobileContainer = styled(Box)`
  margin-bottom: 24px;
`;

export const StyledToolsContainer = styled(Flex)`
  border-color: ${({ theme }) => theme.colors.cardBorder};
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  padding: 24px 0;
  margin-bottom: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    border-top-width: 0;
    border-bottom-width: 0;
    padding: 0 0;
    margin-bottom: 0;
  }
`;

export const StyledSocialLinks = styled(SocialLinks)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.cardBorder};
`;

export const StyledText = styled.span`
  color: ${({ theme }) => theme.colors.textSubtle};
`;
